import React, { useState } from "react";

export async function getSportsOrigin() {
  const response = await fetch("/api/sso/vyralsports/destination", { cache: "no-store" });
  if (!response.ok) throw new Error("VyralSports is unavailable. Please try again later.");
  const { origin } = await response.json();
  return origin;
}

export default function SportsLinks({ onClose }) {
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  async function leave(event, sport) {
    event.preventDefault();
    if (busy || !window.confirm("You are leaving VyralNews and continuing to VyralSports. Continue?")) return;
    setBusy(true);
    setError("");
    try {
      const origin = await getSportsOrigin();
      const destination = new URL("/api/auth/vyralnews/start", origin);
      destination.searchParams.set("sport", sport);
      onClose();
      window.location.assign(destination.toString());
    } catch (err) {
      setError(err.message);
      setBusy(false);
    }
  }
  return <>
    {["all", "football", "basketball", "soccer", "baseball"].map(sport => (
      <button key={sport} type="button" className="dropdown-item"
        disabled={busy} onClick={event => leave(event, sport)}>
        {sport === "all" ? "All Sports" : sport[0].toUpperCase() + sport.slice(1)}
      </button>
    ))}
    {error && <p role="alert">{error}</p>}
  </>;
}